<template>
  <div class="window service-window packaging-service-edit-window" v-show="isVisible">
    <span class="close" title="Закрыть" @click="closeWindow"><img src="../image/cancel.svg"></span>
    <div class="window-title">Доставка упаковки</div>
    <div class="form">
      <div class="title">Описание услуги:</div>
      <div class="dop-info">
        <div>
          <div class="fieldset">
            <label class="fieldset-title">Время прибытия</label>
            <fieldset><input type="text" v-mask="'##:##'" v-model="time"></fieldset>
          </div>
          <div class="fieldset">
            <label class="fieldset-title">Адрес</label>
            <fieldset>
              <select v-model="shippingPackingService.address" v-if="Object.keys(shippingPackingService).length !== 0 && shippingPackingService.address.id === 0">
                <option v-for="address in addressesFromOrder" :value="address">
                  {{ address.place + address.comment }}
                </option>
              </select>
              <select v-model="shippingPackingService.address" v-if="Object.keys(shippingPackingService).length !== 0 &&  shippingPackingService.address.id !== 0">
                <option :value="shippingPackingService.address">
                  {{ shippingPackingService.address.place + shippingPackingService.address.comment }}
                </option>
              </select>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="buttons">
        <button type="button" class="save-button" @click="save">Сохранить</button>
      </div>
    </div>
  </div>
</template>
<script>
    import utils from '@/utils'
    import {mask} from 'vue-the-mask'

    export default {
  name: 'ShippingPacking',

  directives: {
    mask
  },

  props: ['isVisible', 'index', 'addressesFromOrder'],

  watch: {
    isVisible (val) {
      if (val) {
        this.shippingPackingService = this.$store.getters.groupedServices[this.index][0]
      }
    }
  },

  data () {
    return {
      shippingPackingService: {}
    }
  },

  computed: {
    time: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.shippingPackingService.date)
      },

      set (value) {
        if (value.length == 5) {
          let date = new Date(this.shippingPackingService.date)
          date.setHours(0, 0, 0, 0)
          this.shippingPackingService.date = new Date(date.getTime() + utils.getLongFromFormattedTimeString(value)).getTime()
        }
      }
    }
  },

  methods: {
    save () {
      let serviceData = {
        address: this.shippingPackingService.address,
        category: this.shippingPackingService.category,
        date: this.shippingPackingService.date,
        pathToClass: this.shippingPackingService.pathToClass,
        surchargeByRegionInHours: this.shippingPackingService.surchargeByRegionInHours,
        type: this.shippingPackingService.type
      }
      this.$store.commit('updateGroupedServiceByIndex', {
        index: this.index,
        groupedService: [this.shippingPackingService],
        serviceData: serviceData
      })
      this.closeWindow()
    },

    closeWindow () {
      this.$emit('close-window', false)
    }
  }
}
</script>
